// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"249":"58806114","559":"38e26df0","686":"936bf21a","962":"ca96b446"}[chunkId] + ".chunk.js";
};